import { MenuT } from 'types/frontend/Menu';
import { MyInfoT } from 'types/shared/core/User';

// 나중에 다국어 함수로 대체
const t = (str: string) => str;

const attendanceMenuRootPath = '/teacherSide/attendance';

const attendanceMenu: MenuT = [
  {
    title: t('출결'),
    items: [
      {
        title: t('오늘의 출결'),
        path: `${attendanceMenuRootPath}/student/ofToday`,
      },
      {
        title: t('일자별 출결'),
        path: `${attendanceMenuRootPath}/student/byDate`,
        accessablePositions: ['director', 'assistantDirector'],
      },
      {
        title: t('월간 출결 기록'),
        path: `${attendanceMenuRootPath}/student/all`,
        accessablePositions: ['director', 'assistantDirector'],
      },
      {
        title: t('나의 출결'),
        path: `${attendanceMenuRootPath}/student/list`,
      },
    ],
  },
  {
    title: t('스케줄'),
    items: [
      {
        title: t('주간 등하원 스케줄'),
        path: `${attendanceMenuRootPath}/student/weeklyInfo`,
        accessablePositions: ['director', 'assistantDirector'],
        visibilityCriteria: (myInfo: MyInfoT | null) =>
          !!myInfo?.teacherInfo?.academy.insiderSetting?.feaAttendanceRealtime,
      },
      {
        title: t('일자별 스케줄'),
        path: `${attendanceMenuRootPath}/student/scheduleByDate`,
        visibilityCriteria: (myInfo: MyInfoT | null) =>
          !!myInfo?.teacherInfo?.academy.insiderSetting?.feaAttendanceRealtime,
      },
      {
        title: t('실시간 스케줄'),
        path: `${attendanceMenuRootPath}/student/realtime`,
        visibilityCriteria: (myInfo: MyInfoT | null) =>
          !!myInfo?.teacherInfo?.academy.insiderSetting?.feaAttendanceRealtime,
      },
    ],
  },
  {
    title: t('근태'),
    items: [
      {
        title: t('나의 근태'),
        path: `${attendanceMenuRootPath}/teacher/list`,
      },
      {
        title: t('월간 근태 기록'),
        path: `${attendanceMenuRootPath}/teacher/all`,
        accessablePositions: ['director', 'assistantDirector'],
      },
    ],
  },
];

export { attendanceMenu };
